import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core';
import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core';
import { api } from '@portal/arq-portal-core';
import {
    useParams
  } from "react-router-dom";

interface Audiencia {
    Id: number, 
    Nombre: string
}
interface Componente {
    CodComponente:string
}
interface Rol {
    Nombre:string,
    Sid:string
}
export const InfoUsuario = (props:any) =>  {
    
    const [perfil, setPerfil] = useState<any>(null);
    const [audiencias, setAudiencias] = useState<Audiencia[]>();
    const [portal, setPortal] = useState<any>(null);
    const [roles, setRoles] = useState<Rol[]>();
    const [componentes, setComponentes] = useState<Componente[]>(); 
    const useStyles = makeStyles({
        InfoUsuario:{
            textAlign: 'center', 
            padding: '2%', 
            '& h3': {
                color:'#606060',
                fontFamily: 'CO-Bold',
                borderBottom: '1px solid #919191',
                marginBottom: '0px',
                paddingBottom: '20px',
                fontSize: '16px',
            },
            '@media screen and (max-width: 1250px)': {
                '& .MuiTableHead-root': {
                    display: "none",
                },
                '& td.MuiTableCell-root.MuiTableCell-body': {
                    display: "block",
                },
                '& td.MuiTableCell-root.MuiTableCell-body:before': {
                     content: 'attr(data-headcell) ": "',
                     fontWeight: 'bold',
                     color: '#DC0028',
                     float: 'left',
                     minWidth: '100px'
                },
            },
        },
        InfoTable:{
            textAlign: 'center', 
            width: 'calc(33.3% - 30px)',
            padding: '30px',
            '@media screen and (max-width: 1250px)': {
                width: 'calc(100% - 30px)',
                padding: '15px',
            },
            '& h3': {
                color:'#606060',
                fontFamily: 'CO-Bold',
                borderBottom: '1px solid #919191',
                marginBottom: '0px',
                paddingBottom: '20px',
                fontSize: '16px',
            },
            //border:'2px solid black'
        },
        TableContainer:{
            display:'flex',
            flexDirection: 'row',
            '@media screen and (max-width: 1250px)': {
                display: 'block',
            },
            //border:'2px solid black'
        },
        Cabecera:{
            fontWeight: 'bold', 
            borderColor: '#919191', 
            color: '#dc0028'
        }
    });

    const classes = useStyles(props);

    let {dominio, usuario} = useParams();

    React.useEffect(()=>{
        api.post("/BE/infousuario/", { Entrada: { Dominio: dominio, Usuario: usuario }}).then(x => {

              let data = x.Salida
              setPerfil(data.PerfilUsuario);
              setAudiencias(data.Audiencias);
              setComponentes(data.Componentes);
              setPortal(data.Portal);
              setRoles(data.Roles);
              console.log("Usuarios: ")
              console.log(x);
            
        });       
    }, []);

    return(
         <React.Fragment>
             {(perfil != null || portal != null) &&
                 <div className={classes.InfoUsuario}>
                 <h3>Información general del usuario {usuario? dominio+"\\"+usuario : "actual"}</h3>
                 <TableContainer>
                     <Table>
                         <TableHead>
                             <TableRow>
                                <TableCell className = {classes.Cabecera}>CIA</TableCell>
                                <TableCell className = {classes.Cabecera}>Inicial</TableCell>
                                <TableCell className = {classes.Cabecera}>Nombre</TableCell>
                                <TableCell className = {classes.Cabecera}>Apellidos</TableCell>
                                <TableCell className = {classes.Cabecera}>Mail</TableCell>
                                <TableCell className = {classes.Cabecera}>Departamento</TableCell>
                                <TableCell className = {classes.Cabecera}>Id</TableCell>
                                <TableCell className = {classes.Cabecera}>Phone</TableCell>
                                <TableCell className = {classes.Cabecera}>Título</TableCell>
                                <TableCell className = {classes.Cabecera}>User</TableCell>
                                <TableCell className = {classes.Cabecera}>Portal</TableCell> 
                             </TableRow>
                         </TableHead>
                         <TableBody>
                             <TableRow>
                                <TableCell data-headcell={"CIA"}>{perfil.cia}</TableCell>
                                <TableCell data-headcell={"Inicial"}>{perfil.ini}</TableCell>
                                <TableCell data-headcell={"Nombre"}>{perfil.fn}</TableCell>
                                <TableCell data-headcell={"Apellidos"}>{perfil.sn}</TableCell>
                                <TableCell data-headcell={"Mail"}>{perfil.mail}</TableCell>
                                <TableCell data-headcell={"Departamento"}>{perfil.dpt}</TableCell>
                                <TableCell data-headcell={"Id"}>{perfil.id}</TableCell>
                                <TableCell data-headcell={"Phone"}>{perfil.phone}</TableCell>
                                <TableCell data-headcell={"Título"}>{perfil.ttl}</TableCell>
                                <TableCell data-headcell={"User"}>{perfil.user}</TableCell>  
                                <TableCell data-headcell={"Portal"}>{portal}</TableCell> 
                             </TableRow>
                             </TableBody>
                         </Table>
                     </TableContainer>
                 </div>
             }
            <div className = {classes.TableContainer}>
            {(audiencias != null) &&
                <div className={classes.InfoTable}>
                    <h3>Audiencias relacionadas con el usuario</h3>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell className = {classes.Cabecera}>Id</TableCell>
                                    <TableCell className = {classes.Cabecera}>Nombre</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {audiencias.map(audiencia =>(
                                    <TableRow>
                                        <TableCell>{audiencia.Id}</TableCell>
                                        <TableCell>{audiencia.Nombre}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
             }

            {(componentes != null) &&
                <div className={classes.InfoTable}>
                    <h3>Componentes relacionados con el usuario</h3>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell className = {classes.Cabecera}>Código Componente</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {componentes.map(component =>(
                                    <TableRow>
                                        <TableCell>{component.CodComponente}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            }
            {(roles != null) &&
                <div className={classes.InfoTable}>
                    <h3>Roles relacionados con el usuario</h3>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell className = {classes.Cabecera}>Nombre</TableCell>
                                    <TableCell className = {classes.Cabecera}>Sid</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {roles.map(rol =>(
                                    <TableRow>
                                        <TableCell>{rol.Nombre}</TableCell>
                                        <TableCell>{rol.Sid}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            }
            </div>
         </React.Fragment>
         
    )
    
}

export default InfoUsuario